import React from 'react'
import SingleSelect, { type SingleSelectHandle } from '../../ui/SingleSelect'

export interface WeldIdCatalogSelectProps {
  value: string
  options: string[]
  onChange: (value: string) => void
  onCreateOption: (value: string) => Promise<string>
  className?: string
  errorMessage?: string | null
  selectRef?: React.Ref<SingleSelectHandle>
  interactionLocked?: boolean
  lockedHint?: string
  onLockedInteraction?: () => void
}

/** Floor Sheet–style Weld ID catalog picker (shared by Floor Sheet row + upload mode dialog). */
export default function WeldIdCatalogSelect({
  value,
  options,
  onChange,
  onCreateOption,
  className = 'w-full',
  errorMessage,
  selectRef,
  interactionLocked,
  lockedHint,
  onLockedInteraction
}: WeldIdCatalogSelectProps) {
  return (
    <div>
      <SingleSelect
        ref={selectRef}
        className={className}
        value={value}
        options={options}
        onChange={onChange}
        placeholder="Enter weld ID"
        addLabel="Add Weld ID"
        createModalTitle="Add Weld ID"
        createFieldLabel="Weld ID"
        createInputPlaceholder="e.g. W-001"
        onCreateOption={onCreateOption}
        interactionLocked={interactionLocked}
        lockedHint={lockedHint}
        onLockedInteraction={onLockedInteraction}
      />
      {errorMessage ? (
        <p className="mt-1 text-[11px] text-error-600" data-testid="weld-id-catalog-select-error">
          {errorMessage}
        </p>
      ) : null}
    </div>
  )
}
